import { Pipe, PipeTransform } from '@angular/core';
import { Tooth } from '@libs/ui-lib';

@Pipe({
  name: 'findToothByPosition',
  standalone: true,
})
export class FindToothByPositionPipe implements PipeTransform {
  public transform(teeth: Tooth[], position: number): Tooth {
    return teeth.find((t) => t.position === position)!;
  }
}
